import dayjs from 'dayjs';
import { v4 as uuid } from 'uuid';
import { OptionsToString, StringToOptions } from '../../libs/util/util_string';
import { new_ErrorAlert } from '../export_spwk/ExportManager';
import { SpwkUtil } from './SpwkUtil';
import { SpwkUtilV3 } from './SpwkUtilV3';
import { UniForm } from './UniForm';

export class UniAnswer {

  static END_POINT = "uni_answer";

  serno = 0;
  guid;//= uuid();

  member_guid = "";

  form_guid = "";

  /** 是否為特作 */
  IsSpwk() {
    return (this.form_guid === '');
  }

  /** 問卷完成日期 */
  rec_dt = "2999-01-01 00:00:00";
  IsQuestDone() {
    return !IsYear2999(this.rec_dt);
  }
  /** 特作通用項目FormGuid */
  base_form_guid = "";

  /** 
   * 注意! 需與 spwk_func_guid_list 順序相同
   *  特作問卷 FormGuid 問卷版本列表 
   **/
  spwk_form_guid_list = "";
  getSpwkFormGuidList(): string[] { return StringToOptions(this.spwk_form_guid_list); }
  __setSpwkFormGuidList(guids: string[]): void { this.spwk_form_guid_list = OptionsToString(guids); }

  /** 
   * 注意! 需與 spwk_form_guid_list 順序相同
   * 特作問卷 FuncGuid 問卷功能列表 A01、A98、(guid)...
   **/
  spwk_func_guid_list = "";
  getSpwkFuncGuidList(): string[] { return StringToOptions(this.spwk_func_guid_list); }
  __setSpwkFuncGuidList(guids: string[]): void { this.spwk_func_guid_list = OptionsToString(guids); }

  setSpwkFormList(form_list: UniForm[]) {
    // 這兩組要求順序一模一樣
    this.__setSpwkFuncGuidList(form_list.map(x => x.func_guid));// 問卷代碼對照(方便日後查詢)
    this.__setSpwkFormGuidList(form_list.map(x => x.guid));// 問卷版本對照(當時填寫的問卷版本) 
  }

  m01 = "";
  m02 = "";
  m03 = "";
  m04 = "";
  m05 = "";
  m06 = "";
  m07 = "";
  m08 = "";
  m09 = "";
  m10 = "";

  m11 = "";
  m12 = "";
  m13 = "";
  m14 = "";
  m15 = "";
  m16 = "";
  m17 = "";
  m18 = "";
  m19 = "";
  m20 = "";

  //#region C#匯入相關欄位
  ui_prev_work = "";
  ui_prev_work_start = "";
  ui_prev_work_end = "";
  ui_curr_work = "";
  ui_curr_work_start = "";
  ui_curr_work_end = "";
  ui_a01_ch04 = "";
  ui_b02_ch04 = "";
  ui_bxx_ch04 = "";
  ui_a01_ch06 = "";
  ui_b02_ch06 = "";
  ui_bxx_ch06 = "";


  xls_ui_done_status = "";
  xls_ui_done_list = "";
  xls_ui_done_at = "2999-01-01 00:00:00";
  xls_spwk_done_status = "";
  xls_spwk_done_list = "";
  xls_spwk_done_at = "2999-01-01 00:00:00";
  //#endregion

  //#region --- View: Func、Form ---
  func_guid: string | null = null;
  func_code: string | null = null;
  //#endregion

  //#region --- View: Member ---
  project_guid = "";
  member_code = "";
  member_name = "";
  company_tax_id = "";
  member_gender: Number = 0;
  his_upload_dt = "";
  gov_upload_dt = "";
  ui_upload_dt = "";
  his_upload_err_msg = '';
  gov_upload_err_msg = '';
  ui_upload_err_msg = '';
  IsHisUploadDone() {
    return !IsYear2999(this.his_upload_dt);
  }


  IsGovUploadDone() {
    return !IsYear2999(this.gov_upload_dt);
  }
  IsUiUploadDone() {
    return !IsYear2999(this.gov_upload_dt);
  }
  //#endregion


  constructor() {
    this.guid = uuid();
  }

  /**
   * 存檔用，將介面上的 rhf 資料，寫入對應的 column
   */
  SetValueBySpwkRhfData(member_guid: string, rhf_data: any) {
    let answer: any = this;
    answer.member_guid = member_guid;

    for (const m of Col_x_Rhf_Mapping) {
      const val = rhf_data[m.rhf_name];

      if (val === undefined) {
        answer[m.col_name] = "";
      } else {
        answer[m.col_name] = JSON.stringify(val, null, 4);
      }

    }
  }

  /**
   * 讀檔用，將 DB 的資料轉為 Rhf 的格式
   */
  ConvertToSpwkRhfData() {
    let answer: any = this;

    let data: any = {};

    for (const m of Col_x_Rhf_Mapping) {
      const json = answer[m.col_name];

      if (json === "") {
        //pass;
      } else {
        data[m.rhf_name] = JSON.parse(json);
      }
    }
    return data;
  }


  /** 將一般問卷轉為 RhfData 
   * 基本上就是把 m01、m02... 改為立體的結構，並將他們從Json轉回Object
  */
  ConvertToCommonRhfData() {
    let answer: any = this;
    let data: any = {};

    for (let i = 1; i <= SpwkUtilV3.ANS_M_CNT; i++) {
      const col_name = "m" + ("" + i).padStart(2, "0");// m01、m02....m20
      const json = answer[col_name];

      if (json === "") {
        //pass;
      } else {
        const rhf_name = col_name;// 目前故意把 rhf.欄位跟資料庫一樣方便處理
        data[rhf_name] = JSON.parse(json);
      }
    }

    return data;
  }

  /**
* 一般問卷存檔用，將介面上的 rhf 資料，寫入對應的 column
*/
  SetValueByCommonRhfData(member_guid: string, rhf_data: any) {
    let answer: any = this;
    answer.member_guid = member_guid;

    for (let i = 1; i <= SpwkUtilV3.ANS_M_CNT; i++) {
      const rhf_name = "m" + ("" + i).padStart(2, "0");// m01、m02....m20
      const val = rhf_data[rhf_name];

      if (val === undefined) {
        answer[rhf_name] = "";
      } else {
        answer[rhf_name] = JSON.stringify(val, null, 4);
      }
    }

  }
}



// }
/**
 定義特作 要與 Answer 的哪個欄位配對
*/
const Col_x_Rhf_Mapping: { rhf_name: string, col_name: string }[]
  = [
    { col_name: "m01", rhf_name: SpwkUtil.CHAPTER_基本資料 },
    { col_name: "m02", rhf_name: SpwkUtil.CHAPTER_作業經歷 },
    { col_name: "m03", rhf_name: SpwkUtil.CHAPTER_檢查時期 },
    { col_name: "m04", rhf_name: SpwkUtil.CHAPTER_既往病史 },
    { col_name: "m05", rhf_name: SpwkUtil.CHAPTER_生活習慣 },
    { col_name: "m06", rhf_name: SpwkUtil.CHAPTER_自覺症狀 },
    { col_name: "m07", rhf_name: SpwkUtil.CHAPTER_環境監測 },

    { col_name: "m14", rhf_name: SpwkUtil.CHAPTER_既往病史_噪音作業 },
    { col_name: "m16", rhf_name: SpwkUtil.CHAPTER_自覺症狀_噪音作業 },

    { col_name: "m18", rhf_name: SpwkUtil.CHAPTER_疲勞狀況 },
  ]

function IsYear2999(dt_str: string) {
  if (dt_str == null || dt_str === "") {
    throw new_ErrorAlert("4646116 dt_str: 沒有填值 !!!");
  } else {
    return dayjs(dt_str).year() === 2999;
  }
}